// extracted by mini-css-extract-plugin
module.exports = {"verticalTitle":"CatalogPage-module--verticalTitle--3W-bh","container":"CatalogPage-module--container--1w3Hl","projectItem":"CatalogPage-module--projectItem--1aPmZ"};